export const LTS_PAGES = [
  'understand-your-body',
  'weightloss-support-transition',
  'you-can-too-transition',
  'motivation-transition',
  'calorie-tracking-transition',
  'simple-idea-transition',
  'no-starving-transition',
  'success-path-transition',
  'excellent-news-transition',
  'we-help-transition',
  'normal-transition',
  'remember-goals-transition',
  'goal-first-step-transition',
  'good-job-transition',
  'excellent-transition',
  'completely-normal-transition',
  'not-alone-transition',
  'small-steps-transition',
  'environment-transition',
  'busy-parents-transition',
  'find-time-transition',
  'self-made-transition',
  'be-prepared-transition',
  'thank-you-transition',
  'weekends-support-transition',
  'accounted-transition',
  'recipes-transition',
  'bigger-community-transition',

  'calorie-free-transition',
  'balance-transition',
  'flexible-meal-transition',
  'mindset-intro',
  'speed-fuels-success',
  'diet-restrictions',
  'weightloss-approach',
  'nutrition-transition',
  'no-diets-transition',
  'fasting-transition',
  'flexible-plan-transition',
  'analyzing-activity',
  'calorie-needs-corrected',
  'building-meal-plan',
  'analyzing-body',
  'calorie-needs',
  'analyzing',
  'analyzing-2',
  'analyzing-3',
  'analyzing-4',
  'budget-transition',
  'meal-transition',
  'best-app',
  'email-2',
  'glp-diet',
  'preland',
  'feel-like',
  'this-will-work',
  'individual-approach',
  'guide-you',
  'lts-photo-example',
  'face-scan',
  'face-scan-animation',
  'face-scan-id',
  'lts-result',
  'no-more-cravings',
  'without-exercise',
  'never-quits',
  'analyzing-answers',
  'upsale-without-trial',
  'take-pictures',
  'almost-done',
  'web-upsale-1',
  'web-upsale-3',
  'web-upsale-4',
  'web-upsale-5',
  'personal-plan',
  'personal-plan-2',
  'personal-plan-3',
  'personal-plan-4',
  'personal-plan-metabolism',
  'personal-plan-dynamic',
  'paywall',
  'upsale-nutrition-bundle',
  'upsale-dynamic',
  'full-body-photo',
];